import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { HttpService } from './http.service';
import { MitraGuard } from './mitra.guard';

@Injectable({
  providedIn: 'root'
})
export class MitraLoginGuard implements CanActivate {
  constructor(
    private http: HttpService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;

    // Jika tidak ada token, izinkan pengguna membuka halaman login
    if (!token) {
      MitraGuard.clearCache();
      return of(true);
    }

    // Jika token sudah tervalidasi dan user id tersimpan di cache
    if (token === MitraGuard.cachedToken && MitraGuard.cachedUserId) {
      return of(this.router.createUrlTree(['/mitra', MitraGuard.cachedUserId]));
    }

    // Validasi token ke server untuk mendapatkan user id customer
    return this.http.get('/api/v1/wp/mitra/auth/get-user-id').pipe(
      tap((res: any) => {
        const userId = res?.data?.user_id;
        if (userId) {
          MitraGuard.cachedToken = token;
          MitraGuard.cachedUserId = String(userId);
        }
      }),
      map((res: any) => {
        const userId = res?.data?.user_id;
        if (userId) {
          // Token valid: langsung arahkan ke home customer (/mitra/:id)
          return this.router.createUrlTree(['/mitra', userId]);
        }

        // Token tidak valid (tidak ada user_id)
        localStorage.removeItem('token');
        MitraGuard.clearCache();
        return true;
      }),
      catchError(() => {
        // Token kadaluarsa atau tidak valid: hapus token dan izinkan ke halaman login
        localStorage.removeItem('token');
        MitraGuard.clearCache();
        return of(true);
      })
    );
  }
}
